define('scrollPlay',[],function() {

  var videos = [].slice.call(document.querySelectorAll("[scrollplay]"));

  videos.forEach(function(video) {
    video.addEventListener("click", function() {
      video.loop = false;
      video.currentTime = 0;
      video.play();
    });
    video.preload = true;
  });

  window.addEventListener("scroll", function() {
    videos = videos.filter(function(video) {
      var bounds = video.getBoundingClientRect();
      if (bounds.top > 0 && bounds.bottom < window.innerHeight && video.readyState == 4) {
        video.play();
        return false;
      }
      return true;
    });
  });

});
